import { configureStore } from "@reduxjs/toolkit";
import timerReducer from "../processvideo/timerSlice";

const store = configureStore({
  reducer: {
    timer: timerReducer, // Use a meaningful key (e.g., "timer" instead of "video")
  },
});

export default store;
